/**
 * Numbered Steps block script.
 *
 * Stagger reveal across the ordered list items as the section enters view.
 * Each step (badge + heading + description) fades up in sequence — read order
 * is the cascade order, which reinforces the "follow these steps" affordance.
 */

import { revealStagger, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-numbered-steps').forEach((section) => {
		const list = section.querySelector('ol');
		if (!list) return;

		revealStagger(list, {
			childSelector: ':scope > li',
			stagger: 0.1,
			duration: motionTokens.durMd,
		});
	});
});
